import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setErr("Passwords do not match");
    if (pw.length < 8) return setErr("At least 8 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset");
      nav("/login");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="brut-card p-8 max-w-md w-full brut-shadow-lg">
        <div className="label-mono">New password</div>
        <div className="font-chivo font-black text-3xl uppercase tracking-tighter">Reset</div>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="label-mono">New password</label>
            <input required type="password" data-testid="rp-new"
              value={pw} onChange={(e) => setPw(e.target.value)}
              className="w-full border border-black px-3 py-2 mt-1" />
          </div>
          <div>
            <label className="label-mono">Confirm</label>
            <input required type="password" data-testid="rp-confirm"
              value={pw2} onChange={(e) => setPw2(e.target.value)}
              className="w-full border border-black px-3 py-2 mt-1" />
          </div>
          {err && <div className="border border-red-600 bg-red-50 p-2 text-xs text-red-700">{err}</div>}
          <button disabled={loading} data-testid="rp-submit"
            className="w-full bg-black text-white py-3 uppercase text-xs tracking-widest font-bold border border-black">
            {loading ? "Saving…" : "Reset password"}
          </button>
        </form>
        <Link to="/login" className="mt-4 inline-block text-[11px] uppercase tracking-widest hover:underline">Back to sign in</Link>
      </div>
    </div>
  );
}
